import api from "../api/api";

// Get JWT from localStorage
const getAuthHeaders = () => {
  const token = localStorage.getItem("token"); // ensure token is saved after login
  if (!token) throw new Error("No token found. Please login first.");
  return {
    headers: { Authorization: `Bearer ${token}` },
  };
};

// Register teacher face
export const registerTeacherFace = async (embedding) => {
  const res = await api.post(
    `/api/teacher-attendance/register-face`,
    { embedding },
    getAuthHeaders()
  );
  return res.data;
};

// Mark attendance
export const markAttendance = async (embedding) => {
  const res = await api.post(
    `/api/teacher-attendance/mark-attendance`,
    { embedding },
    getAuthHeaders()
  );
  return res.data;
};

// Fetch attendance history
export const fetchTeacherHistory = async () => {
  const res = await api.get(`/api/teacher-attendance/history`, getAuthHeaders());
  return res.data;
};

// Fetch if teacher face is already registered
export const fetchTeacherFace = async () => {
  try {
    const res = await api.get(`/api/teacher-attendance/face`, getAuthHeaders());
    return res.data; // { registered: true/false }
  } catch (err) {
    console.error("❌ fetchTeacherFace error:", err);
    return { registered: false };
  }
};
